// extracted by mini-css-extract-plugin
export default {"file-attachment-div":"_file-attachment-div_AEaqo0","link":"_link_GAFFWj"};